// Custom Messages

export const deCustomMessages = {
    "pages": {
        "login": {
            "sighInTitle": "Melde dich bei SINETOS an",
            "username": "Benutzername",
            "email": "E-Mail",
            "password": "Passwort",
            "rememberMe": "Angemeldet bleiben",
            "welcome": "Willkommen",
            "login": "Anmelden"
        },
        "welcome": {
            "home": "Startseite",
            "features": "Funktionen",
            "events": "Veranstaltungen",
            "pricing": "Preise",
            "title": "Finde Immobilien in Griechenland und Zypern",
            "login": "Anmelden",
            "logout": "Abmelden",
            "dashboard": "Dashboard"
        },
        "emailAccount": {
            "createUser": "Sende E-Mail an",
            "sendTestEmailToTitle": "Sende Test-E-Mail, um sicherzustellen, dass alles richtig konfiguriert ist."
        },
        "portfolio": {
            "upload": "Hochladen",
            "download": "Herunterladen",
            "approval": "Genehmigung",
            "emailInfo": "E-Mail-Informationen",
            "restrictions": {
                "maxFileSize": "Dokumentgrößenbeschränkung < 2.097.152 KB"
            }
        }
    },
    "common": {
        "cancel": "Abbrechen",
        "employee": "Mitarbeiter",
        "user": "Benutzer",
        "confirmation": "Bestätigung",
        "delete": "Löschen",
        "settings": "Einstellungen",
        "actions": "Aktionen",
        "languages": "Sprachen",
        "logout": "Abmelden",
        "importResources": "Ressourcen importieren",
        "execute": "Ausführen",
        "clearAll": "Alle Einträge löschen",
        "mark": "Markieren"
    },
    "messages": {
        "deleteFile": "Datei löschen",
        "sendingEmail": "E-Mail wird gesendet",
        "createNewUser": "Neuen Benutzer erstellen.",
        "clearAllCompleted": "Alle Einträge wurden gelöscht.",
        "emailSendingSuccessfullyCompleted": "E-Mail-Versand erfolgreich abgeschlossen.",
        "editSuccessfullyCompleted": "Bearbeitung erfolgreich abgeschlossen.",
        "uploadSuccessfullyCompleted": "Hochladen erfolgreich abgeschlossen.",
        "deleteFileSuccessfullyCompleted": "Dateilöschung erfolgreich abgeschlossen."
    }
};

// Kendo Angular Component Messages
export const deComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty": "Ziehen Sie einen Spaltenkopf hierher, um nach dieser Spalte zu gruppieren.",
    "kendo.grid.noRecords": "Keine Datensätze verfügbar.",
    "kendo.grid.pagerFirstPage": "Zur ersten Seite wechseln.",
    "kendo.grid.pagerPreviousPage": "Zur vorherigen Seite wechseln.",
    "kendo.grid.pagerNextPage": "Zur nächsten Seite wechseln.",
    "kendo.grid.pagerLastPage": "Zur letzten Seite wechseln.",
    "kendo.grid.pagerPage": "Seite",
    "kendo.grid.pagerOf": "von",
    "kendo.grid.pagerItems": "Einträge",
    "kendo.grid.pagerItemsPerPage": "Einträge pro Seite",
    "kendo.grid.pagerPageNumberInputTitle": "Seitennummer",
    "kendo.grid.filter": "Filter",
    "kendo.grid.filterEqOperator": "Ist gleich",
    "kendo.grid.filterNotEqOperator": "Ist ungleich",
    "kendo.grid.filterIsNullOperator": "Ist null",
    "kendo.grid.filterIsNotNullOperator": "Ist nicht null",
    "kendo.grid.filterIsEmptyOperator": "Ist leer",
    "kendo.grid.filterIsNotEmptyOperator": "Ist nicht leer",
    "kendo.grid.filterStartsWithOperator": "Beginnt mit",
    "kendo.grid.filterContainsOperator": "Enthält",
    "kendo.grid.filterNotContainsOperator": "Enthält nicht",
    "kendo.grid.filterEndsWithOperator": "Endet mit",
    "kendo.grid.filterGteOperator": "Ist größer oder gleich",
    "kendo.grid.filterGtOperator": "Ist größer als",
    "kendo.grid.filterLteOperator": "Ist kleiner oder gleich",
    "kendo.grid.filterLtOperator": "Ist kleiner als",
    "kendo.grid.filterIsTrue": "ist wahr",
    "kendo.grid.filterIsFalse": "ist falsch",
    "kendo.grid.filterBooleanAll": "(Alle)",
    "kendo.grid.filterAfterOrEqualOperator": "Ist nach oder gleich",
    "kendo.grid.filterAfterOperator": "Ist nach",
    "kendo.grid.filterBeforeOperator": "Ist vor",
    "kendo.grid.filterBeforeOrEqualOperator": "Ist vor oder gleich",
    "kendo.grid.filterFilterButton": "Filtern",
    "kendo.grid.filterClearButton": "Löschen",
    "kendo.grid.filterAndLogic": "Und",
    "kendo.grid.filterOrLogic": "Oder",
    "kendo.grid.filterDateToggle": "Kalender umschalten",
    "kendo.grid.filterDateToday": "Heute",
    "kendo.grid.filterNumericDecrement": "Wert verringern",
    "kendo.grid.filterNumericIncrement": "Wert erhöhen",
    "kendo.grid.loading": "Laden",
    "kendo.grid.columns": "Spalten",
    "kendo.grid.lock": "Sperren",
    "kendo.grid.unlock": "Entsperren",
    "kendo.grid.stick": "Anheften",
    "kendo.grid.unstick": "Lösen",
    "kendo.grid.setColumnPosition": "Spaltenposition festlegen",
    "kendo.grid.sortAscending": "Aufsteigend sortieren",
    "kendo.grid.sortDescending": "Absteigend sortieren",
    "kendo.grid.columnsApply": "Anwenden",
    "kendo.grid.columnsReset": "Zurücksetzen",
    "kendo.grid.sortable": "Sortierbar",
    "kendo.grid.sortedAscending": "Aufsteigend sortiert",
    "kendo.grid.sortedDescending": "Absteigend sortiert",
    "kendo.grid.sortedDefault": "Nicht sortiert",
    "kendo.grid.filterInputLabel": "{columnName} Filter",
    "kendo.grid.filterMenuTitle": "{columnName} Filtermenü",
    "kendo.grid.filterMenuOperatorsDropDownLabel": "{columnName} Filteroperatoren",
    "kendo.grid.filterMenuLogicDropDownLabel": "{columnName} Filterlogik",
    "kendo.grid.columnMenu": "{columnName} Spaltenmenü",
    "kendo.grid.selectionCheckboxLabel": "Zeile auswählen",
    "kendo.grid.selectAllCheckboxLabel": "Alle Zeilen auswählen",
    "kendo.grid.pagerLabel": "Seitennavigation, Seite {currentPage} von {totalPages}",
    "kendo.grid.gridLabel": "Datentabelle",
    "kendo.grid.groupCollapse": "Gruppe reduzieren",
    "kendo.grid.groupExpand": "Gruppe erweitern",
    "kendo.grid.detailCollapse": "Details reduzieren",
    "kendo.grid.detailExpand": "Details erweitern",
    "kendo.grid.autosizeThisColumn": "Diese Spalte automatisch anpassen",
    "kendo.grid.autosizeAllColumns": "Alle Spalten automatisch anpassen",
    "kendo.grid.pagerSelectPage": "Seite auswählen",
    "kendo.grid.topToolbarLabel": "Obere Symbolleiste",
    "kendo.grid.bottomToolbarLabel": "Untere Symbolleiste",
    "kendo.grid.groupPanelLabel": "Gruppierungsfeld",
    "kendo.grid.dragRowHandleLabel": "Zeile ziehen",
    "kendo.grid.selectRowCheckboxLabel": "Zeile auswählen",
    "kendo.grid.selectAllRowsCheckboxLabel": "Alle Zeilen auswählen",
    "kendo.grid.filterCellOperatorLabel": "Filteroperatoren für {columnName}",
    "kendo.grid.booleanFilterCellLabel": "Boolean-Filterzelle für {columnName}",
    "kendo.grid.columnMenuFilterTabTitle": "Filter",
    "kendo.grid.columnMenuGeneralTabTitle": "Allgemein",
    "kendo.grid.columnMenuColumnsTabTitle": "Spalten",
    "kendo.grid.groupChipMenuPrevious": "Als vorheriges verschieben",
    "kendo.grid.groupChipMenuNext": "Als nächstes verschieben",
    "kendo.grid.pagerInputLabel": "Geben Sie eine Seitennummer ein",

    // Filter
    "kendo.filter.addExpression": "Ausdruck hinzufügen",
    "kendo.filter.addFilter": "Filter hinzufügen",
    "kendo.filter.addGroup": "Gruppe hinzufügen",
    "kendo.filter.remove": "Entfernen",
    "kendo.filter.editorDateTodayText": "Heute",
    "kendo.filter.editorDateToggleText": "Kalender umschalten",
    "kendo.filter.editorNumericDecrement": "Wert verringern",
    "kendo.filter.editorNumericIncrement": "Wert erhöhen",
    "kendo.filter.filterAfterOperator": "ist später als",
    "kendo.filter.filterAfterOrEqualOperator": "ist später als oder gleich",
    "kendo.filter.filterAndLogic": "und",
    "kendo.filter.filterBeforeOperator": "ist früher als",
    "kendo.filter.filterBeforeOrEqualOperator": "ist früher als oder gleich",
    "kendo.filter.filterBooleanAll": "(Alle)",
    "kendo.filter.filterContainsOperator": "beinhaltet",
    "kendo.filter.filterEndsWithOperator": "endet mit",
    "kendo.filter.filterEqOperator": "ist gleich",
    "kendo.filter.filterExpressionFilters": "Filter",
    "kendo.filter.filterExpressionOperators": "Operatoren",
    "kendo.filter.filterGtOperator": "ist größer als",
    "kendo.filter.filterGteOperator": "ist größer als oder gleich",
    "kendo.filter.filterIsEmptyOperator": "ist leer",
    "kendo.filter.filterIsFalse": "ist falsch",
    "kendo.filter.filterIsTrue": "ist richtig",
    "kendo.filter.filterIsNotEmptyOperator": "ist nicht leer",
    "kendo.filter.filterIsNotNullOperator": "ist nicht Null",
    "kendo.filter.filterIsNullOperator": "ist Null",
    "kendo.filter.filterLtOperator": "ist kleiner als",
    "kendo.filter.filterLteOperator": "ist kleiner oder gleich als",
    "kendo.filter.filterNotContainsOperator": "beinhaltet nicht",
    "kendo.filter.filterNotEqOperator": "ist nicht gleich",
    "kendo.filter.filterOrLogic": "oder",
    "kendo.filter.filterStartsWithOperator": "beginnt mit",
    "kendo.filter.filterFieldAriaLabel": "Feld",
    "kendo.filter.filterOperatorAriaLabel": "Operator",
    "kendo.filter.filterValueAriaLabel": "Wert",
    "kendo.filter.filterAriaLabel": "Filter",
    "kendo.filter.filterToolbarAriaLabel": "Filter Einstellungen",

    // DropDowns
    'kendo.autocomplete.noDataText': 'No data found',
    'kendo.autocomplete.clearTitle': 'Clear',
    'kendo.combobox.noDataText': 'No data found',
    'kendo.combobox.clearTitle': 'Clear',
    'kendo.dropdownlist.noDataText': 'No data found',
    'kendo.dropdownlist.clearTitle': 'Clear',

    // Calendar
    'kendo.calendar.today': 'TODAY',

    // TextBox
    'kendo.textbox.clearTitle': 'Clear',

    // DatePicker
    'kendo.datepicker.today': 'TODAY',
    'kendo.datepicker.toggle': 'Toggle calendar',

    // DateInput
    'kendo.dateinput.increment': 'Increase value',
    'kendo.dateinput.decrement': 'Decrease value',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Increase value',
    'kendo.numerictextbox.decrement': 'Decrease value',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Date tab',
    'kendo.datetimepicker.timeTab': 'Time',
    'kendo.datetimepicker.timeTabLabel': 'Time tab',
    'kendo.datetimepicker.toggle': 'Toggle popup',
    'kendo.datetimepicker.accept': 'Set',
    'kendo.datetimepicker.acceptLabel': 'Set',
    'kendo.datetimepicker.cancel': 'Cancel',
    'kendo.datetimepicker.cancelLabel': 'Cancel',
    'kendo.datetimepicker.now': 'NOW',
    'kendo.datetimepicker.nowLabel': 'Select now',
    'kendo.datetimepicker.today': 'TODAY',
    'kendo.datetimepicker.prevButtonTitle': 'Navigate to previous view',
    'kendo.datetimepicker.nextButtonTitle': 'Navigate to next view',

    // TimePicker
    'kendo.timepicker.accept': 'Set',
    'kendo.timepicker.acceptLabel': 'Set',
    'kendo.timepicker.cancel': 'Cancel',
    'kendo.timepicker.cancelLabel': 'Cancel',
    'kendo.timepicker.now': 'Now',
    'kendo.timepicker.nowLabel': 'Now',
    'kendo.timepicker.toggle': 'Toggle time list',

    // FileSelect
    'kendo.fileselect.cancel': 'Cancel',
    'kendo.fileselect.clearSelectedFiles': 'Clear',
    'kendo.fileselect.dropFilesHere': 'Drop files here to upload',
    'kendo.fileselect.externalDropFilesHere': 'Drag and drop files here to upload',
    'kendo.fileselect.filesBatchStatus': 'files',
    'kendo.fileselect.filesBatchStatusFailed': 'files failed to upload.',
    'kendo.fileselect.filesBatchStatusUploaded': 'files successfully uploaded.',
    'kendo.fileselect.fileStatusFailed': 'File failed to upload.',
    'kendo.fileselect.fileStatusUploaded': 'File successfully uploaded.',
    'kendo.fileselect.headerStatusPaused': 'Paused',
    'kendo.fileselect.headerStatusUploaded': 'Done',
    'kendo.fileselect.headerStatusUploading': 'Uploading...',
    'kendo.fileselect.invalidFileExtension': 'File type not allowed.',
    'kendo.fileselect.invalidMaxFileSize': 'File size too large.',
    'kendo.fileselect.invalidMinFileSize': 'File size too small.',
    'kendo.fileselect.remove': 'Remove',
    'kendo.fileselect.retry': 'Retry',
    'kendo.fileselect.select': 'Select files...',
    'kendo.fileselect.uploadSelectedFiles': 'Upload files',

    // Scheduler
    "kendo.scheduler.agendaViewTitle": "Agenda",
    "kendo.scheduler.allDay": "all day",
    "kendo.scheduler.allEvents": "All events",
    "kendo.scheduler.calendarToday": "TODAY",
    "kendo.scheduler.cancel": "Cancel",
    "kendo.scheduler.save": "Save",
    "kendo.scheduler.editorEventTitle": "Title",
    "kendo.scheduler.editorEventStart": "Start",
    "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
    "kendo.scheduler.editorEventEnd": "End",
    "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
    "kendo.scheduler.dateHeader": "Date",
    "kendo.scheduler.dayViewTitle": "Day",
    "kendo.scheduler.deleteConfirmation": "Are you sure you want to delete this event?",
    "kendo.scheduler.deleteDialogTitle": "Delete Event",
    "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
    "kendo.scheduler.deleteRecurringConfirmation": "Do you want to delete only this event occurrence or the whole series?",
    "kendo.scheduler.deleteRecurringDialogTitle": "Delete Recurring Item",
    "kendo.scheduler.deleteSeries": "Delete the series",
    "kendo.scheduler.deleteTitle": "Delete",
    "kendo.scheduler.destroy": "Delete",
    "kendo.scheduler.editOccurrence": "Edit current occurrence",
    "kendo.scheduler.editorEventAllDay": "All Day Event",
    "kendo.scheduler.editorEventDescription": "Description",
    "kendo.scheduler.editorEventSeparateTimeZones": "End in different Time Zone",
    "kendo.scheduler.editorEventTimeZone": "Specify Time Zone",
    "kendo.scheduler.editorTitle": "Event",
    "kendo.scheduler.editRecurringConfirmation": "Do you want to edit only this event occurrence or the whole series?",
    "kendo.scheduler.editRecurringDialogTitle": "Edit Recurring Item",
    "kendo.scheduler.editSeries": "Edit the series",
    "kendo.scheduler.eventHeader": "Event",
    "kendo.scheduler.monthViewTitle": "Month",
    "kendo.scheduler.multiDayViewTitle": "Multi-Day",
    "kendo.scheduler.nextTitle": "Next",
    "kendo.scheduler.previousTitle": "Previous",
    "kendo.scheduler.recurrenceEditorDailyInterval": "day(s)",
    "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorEndAfter": "After",
    "kendo.scheduler.recurrenceEditorEndLabel": "End",
    "kendo.scheduler.recurrenceEditorEndNever": "Never",
    "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
    "kendo.scheduler.recurrenceEditorEndOn": "On",
    "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Daily",
    "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Monthly",
    "kendo.scheduler.recurrenceEditorFrequenciesNever": "Never",
    "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Weekly",
    "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Yearly",
    "kendo.scheduler.recurrenceEditorMonthlyDay": "Day",
    "kendo.scheduler.recurrenceEditorMonthlyInterval": "month(s)",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "First",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Fourth",
    "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Last",
    "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Second",
    "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Third",
    "kendo.scheduler.recurrenceEditorRepeat": "Repeat",
    "kendo.scheduler.recurrenceEditorWeekdaysDay": "Day",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Weekday",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
    "kendo.scheduler.recurrenceEditorWeeklyInterval": "week(s)",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorYearlyInterval": "year(s)",
    "kendo.scheduler.recurrenceEditorYearlyOf": "of",
    "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repeat on",
    "kendo.scheduler.showFullDay": "Show full day",
    "kendo.scheduler.showWorkDay": "Show business hours",
    "kendo.scheduler.timeHeader": "Time",
    "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
    "kendo.scheduler.timelineViewTitle": "Timeline",
    "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
    "kendo.scheduler.today": "Today",
    "kendo.scheduler.weekViewTitle": "Week",
    "kendo.scheduler.workWeekViewTitle": "Work Week",

    // RecurrenceEditor
    "kendo.recurrenceeditor.dailyInterval": "day(s)",
    "kendo.recurrenceeditor.dailyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.endAfter": "After",
    "kendo.recurrenceeditor.endLabel": "End",
    "kendo.recurrenceeditor.endNever": "Never",
    "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
    "kendo.recurrenceeditor.endOn": "On",
    "kendo.recurrenceeditor.frequenciesDaily": "Daily",
    "kendo.recurrenceeditor.frequenciesMonthly": "Monthly",
    "kendo.recurrenceeditor.frequenciesNever": "Never",
    "kendo.recurrenceeditor.frequenciesWeekly": "Weekly",
    "kendo.recurrenceeditor.frequenciesYearly": "Yearly",
    "kendo.recurrenceeditor.monthlyDay": "Day",
    "kendo.recurrenceeditor.monthlyInterval": "month(s)",
    "kendo.recurrenceeditor.monthlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.monthlyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.offsetPositionsFourth": "Fourth",
    "kendo.recurrenceeditor.offsetPositionsLast": "Last",
    "kendo.recurrenceeditor.offsetPositionsSecond": "Second",
    "kendo.recurrenceeditor.offsetPositionsThird": "Third",
    "kendo.recurrenceeditor.repeat": "Repeat",
    "kendo.recurrenceeditor.weekdaysDay": "Day",
    "kendo.recurrenceeditor.weekdaysWeekday": "Weekday",
    "kendo.recurrenceeditor.weekdaysWeekendday": "Weekend Day",
    "kendo.recurrenceeditor.weeklyInterval": "week(s)",
    "kendo.recurrenceeditor.weeklyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.weeklyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.yearlyInterval": "year(s)",
    "kendo.recurrenceeditor.yearlyOf": "of",
    "kendo.recurrenceeditor.yearlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.yearlyRepeatOn": "Repeat on",
};
